


































import { Component, Vue, Emit } from 'vue-property-decorator'
import { UpdateNavigation } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class UpdateNavigationDialog extends Vue {
  private show = false
  private param: any = {}
  private data: any = {
    iconGileList: [],
    icon: '',
    jumpType: 0,
    status: 0,
  }
  private jumpType = constant.BannerJumpPage
  private statusOp = constant.PlatformStatus
  private navigationExpansionTypeOp = constant.NavigationExpansionType
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    title: [this.requiredRule],
  }

  private classifyTree(parentId: number) {
    return getByParentId(parentId)
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      iconGileList: [],
      icon: '',
      jumpType: 0,
      status: 0,
    }
  }
  @Emit('refresh')
  private refresh() {
    return {}
  }

  public open(param: any) {
    this.show = true
    this.param = param
    this.data = {...this.data,...param}
    if (this.data.icon) {
      this.data.iconGileList = this.data.icon.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.iconGileList = []
    }
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.icon = this.data.iconGileList.map((e: any) => e.url).join(',')
      const p = {
        ...this.data,
      }

      await UpdateNavigation(p)
      this.refresh()
      Message.success('保存')
      this.close()
    })
  }
}
